import utf8 from "utf8";

/**
 * [fileLengthFormat 格式化文件大小]
 * @param  {[int]} total [文件大小]
 * @param  {number} n     [total参数的原始单位如果为Byte，则n设为1，如果为kb，则n设为2，如果为mb，则n设为3，以此类推]
 * @return {[string]}       [带单位的文件大小的字符串]
 */
export function fileLengthFormat(total, n = 1) {
  let format;
  let len = total / 1024.0;
  if (len > 1000) {
    return fileLengthFormat(len, ++n);
  } else {
    switch (n) {
      case 1:
        format = len.toFixed(2) + "KB";
        break;
      case 2:
        format = len.toFixed(2) + "MB";
        break;
      case 3:
        format = len.toFixed(2) + "GB";
        break;
      case 4:
        format = len.toFixed(2) + "TB";
        break;
    }
    return format;
  }
}

export function stringToHex(str) {
  str = $.trim(utf8.encode(str));
  let val = "";
  for (let i = 0; i < str.length; i++) {
    if (val === "") {
      val = str.charCodeAt(i).toString(16);
    } else {
      val += str.charCodeAt(i).toString(16);
    }
  }
  return val;
}

export function getFileType(type, filename) {
  let image = ["image/png", "image/jpeg"];
  let vedio = ["video/quicktime", "video/x-msvideo", "video/mp4"];
  if (!type && !filename) {
    return 6;
  }
  if (
    (filename &&
      filename.substring(filename.lastIndexOf(".") + 1).toLowerCase() ===
        "heic") ||
    image.indexOf(type) > -1
  ) {
    return 1;
  }
  if (vedio.indexOf(type) > -1) {
    return 2;
  }
  return 6;
}
